
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/MultipleCheckboxes.html",
      function () {
        return require("private-next-pages/Forms/MultipleCheckboxes.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/MultipleCheckboxes.html"])
      });
    }
  